import { render, staticRenderFns } from "./PaymentAllocation.vue?vue&type=template&id=6b22104c&scoped=true&"
import script from "./PaymentAllocation.vue?vue&type=script&lang=ts&"
export * from "./PaymentAllocation.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentAllocation.vue?vue&type=style&index=0&id=6b22104c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b22104c",
  null
  
)

export default component.exports